import PropTypes from "prop-types";

export const groheCartDeliveryInterface = {
  price: PropTypes.number,
  name: PropTypes.string,
  time: PropTypes.string,
  cartItems: PropTypes.arrayOf(PropTypes.string), // cartItem id
  // activeDeliveryIndex: PropTypes.number, // not used
};
